<template>
  <div :class="['process-box', bgType == 'black' ? 'black-box' : '']">
    <div :class="['process-item', processVal == 2 ? 'sel' : '']"><span class="val">面试</span></div>
    <div :class="['process-item', processVal == 3 ? 'sel' : '']"><span class="val">录取</span></div>
    <div :class="['process-item', processVal == 4 ? 'sel' : '']"><span class="val">入学</span></div>
  </div>
</template>

<script>
export default {
  name: 'Process',
  props: {
    processVal: {
      type: Number,
      default: 1
    },
    bgType: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
  .process-box{
    width: 275px;
    height: 35px;
    background: #FFFFFF;
    opacity: 0.8;
    border-radius: 8px;
    display: flex;
    justify-content: space-around;
    padding: 5px 0;
    margin: 0 auto 20px auto;
    &.black-box{
      width: 275px;
      padding: 10px 50px;
      height: 35px;
      background: #000;
      opacity: 0.84;
      border-radius: 0;
      .process-item{
        color: #fff;
        &:before{
          width: 4px;
          height: 4px;
          background: #fff;
          border: 2px solid #e7e7e7;
        }
        &:after{
          background: #fff;
        }
      }
    }
    .process-item{
      position: relative;
      color: #414141;
      font-size: 12px;
      .val{
        padding: 2px 10px;
        border-radius: 10px;
      }
      &.sel{
        .val{
          position: relative;
          color: #fff;
          background: #FF5018;
          padding: 2px 10px;
          border-radius: 5px;
          &:after{
            content: '';
            width:0; height:0; font-size:0;border-style:solid;overflow:hidden; position:absolute;
            border-width:5px;border-color:#FF5018 transparent transparent transparent; left:50%; margin-left: -4px; bottom:-7px;
          }
        }
        &:before{
          background: #FF5018;
          border: 2px solid rgb(255, 181, 157);
        }
      }
      &:last-child{
        &:after{
          width: 0;
        }
      }
      &:before{
        position: absolute;
        content: '';
        border-radius: 50%;
        left: 18px;
        bottom: 2px;
        width: 5px;
        height: 5px;
        background: #ababab;
        border: 2px solid #cdcdcd;
      }
      &:after{
        position: absolute;
        content: '';
        left: 32px;
        bottom: 6px;
        width: 49px;
        height: 1px;
        background: #ababab;
      }
    }
  }
</style>
